import React from 'react';
import {  Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ component, isAdminRoute, ...rest }) => {
  const { user, admin } = useSelector((state) => state.auth);

  const isAuthenticated = isAdminRoute ? admin : user;

  return isAuthenticated ? component : <Navigate to={isAdminRoute ? '/' : '/login'} />;
};

export default PrivateRoute;
